/**
 * The entry-fee button. Carried over from V1 as an icon toggle, because an
 * admin taking money at the door is working one-handed and reads a glyph
 * faster than a word.
 *
 * NOT A BLIND TOGGLE. V1's endpoint flipped the value server-side and the
 * client sent nothing; V2's PUT takes an explicit `status`, so the next state
 * is computed here. That is the safer shape anyway — two admins pressing at
 * once both send 'paid' rather than each flipping the other back.
 */

/** V1's glyphs exactly: coin for owed, money bag for settled. */
const UNPAID_ICON = '🪙';
const PAID_ICON   = '💰';

export default function PaymentToggle({ paid, disabled, busy, onChange }) {
  return (
    <button
      type="button"
      className={`hd-icon-toggle ${paid ? 'hd-icon-toggle-on' : ''}`}
      // The glyph does not change meaning on its own — 🪙 and 💰 are both
      // money — so the accessible name carries the state, not just the action.
      aria-label={paid ? 'Paid — mark unpaid' : 'Unpaid — mark paid'}
      title={paid ? 'Mark unpaid' : 'Mark paid'}
      disabled={disabled || busy}
      onClick={() => onChange(paid ? 'unpaid' : 'paid')}
    >
      {paid ? PAID_ICON : UNPAID_ICON}
    </button>
  );
}
